module.exports = __webpack_public_path__ + "img/electronicSaw.0bfb31c9.svg";